export * from './config'
export * from './dataLayer'
export * from './pageTracking'
export * from './eventTracking'

import { initializeDigitalData, setUserInfo, setSiteInfo } from './dataLayer'

export interface DigitalDataPage {
  pageInfo?: Record<string, any>
  content?: Record<string, any>
  [key: string]: any
}

export interface DigitalDataUser {
  userID?: string
  loginState?: 'Authenticated' | 'Unauthenticated'
  userType?: string
  profile?: Record<string, any>
  job?: Record<string, any>
  employee?: Record<string, any>
  timestamp?: string
  userKnown?: boolean
  [key: string]: any
}

export interface DigitalDataSite {
  siteName?: string
  domain?: string
  subdomain?: string
  language?: string
  charSet?: string
  applicationName?: string
  [key: string]: any
}

export interface DigitalData {
  page?: DigitalDataPage
  user?: DigitalDataUser
  site?: DigitalDataSite
  event?: Record<string, any>
  [key: string]: any
}

declare global {
  interface Window {
    digitalData?: DigitalData
    _satellite?: {
      track: (eventName: string) => void
      kpCustomEvent?: (
        eventName: string,
        payload?: {
          pageName?: string
          [key: string]: any
        }
      ) => void
      [key: string]: any
    }
  }
}

let analyticsInitialized = false

/** Initializes the CJA data layer once per session, once user data is available. */
export const initializeAnalytics = (userData: {
  nuid?: string
  region?: string
  userType?: string
  jobRole?: string
  employeeTenure?: string
  union?: string
  workforceClass?: string
}): void => {
  if (analyticsInitialized) return

  initializeDigitalData()
  setUserInfo({
    ...userData,
    loginState: userData.nuid ? 'Authenticated' : 'Unauthenticated',
  })
  setSiteInfo()

  analyticsInitialized = true
}
